<div class="body-override" *ngIf="!loadingTheme">
  <div class="solid-fallback-background"></div>
  <div class="prelogin-background"></div>
  <div class="container">
    <div class="prelogin-logo-container">
      <a routerLink="/"><img class="prelogin-logo" src="../../../../assets/hubtiger_logo_full.png"></a>
      <div class="custom_logo"></div>
    </div>
    <div class="prelogin-container">
      <div>
        <div class="title">{{'onboarding.button.reset_password'| translate}}</div>
          <div class="row margin-top-32">
            <div class="col-md-12">
              <div>
                <div class="input-container">
                  <input pInputText [(ngModel)]="password" type="password" name="password" class="password"
                    placeholder="{{ 'general.password' | translate }}" />
                </div>
                <div class="input-container margin-top-16">
                  <input pInputText [(ngModel)]="verifyPassword" type="password" name="passwordverify" class="password"
                    placeholder="{{ 'general.confirm-password' | translate }}" />
                </div>
                <div>
                  <button style="margin-bottom: 10px" type="submit" class="btn btn-primary" (click)="setPassword()"><i
                      class="fa fa-spin fa-spinner" *ngIf="settingPassword"></i><span *ngIf="!settingPassword">{{'cyclist.set_new_password' | translate }}</span><span *ngIf="settingPassword">{{'cyclist.setting_password' | translate }}</span> </button>
                </div>
                <div class="error" *ngIf="error">
                  <span>{{errorMessage}}</span>
                </div>
                <div class="success" *ngIf="success">
                  <span>{{successMessage}}</span>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
